var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMemory = function SvgMemory(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C7 0.447715 7.44772 0 8 0C8.55229 0 9 0.447715 9 1V4H12V1C12 0.447715 12.4477 0 13 0C13.5523 0 14 0.447715 14 1V4H17V1C17 0.447715 17.4477 0 18 0C18.5523 0 19 0.447715 19 1V4.12602C20.4056 4.4878 21.5122 5.59439 21.874 7H25C25.5523 7 26 7.44772 26 8C26 8.55229 25.5523 9 25 9H22V12H25C25.5523 12 26 12.4477 26 13C26 13.5523 25.5523 14 25 14H22V17H25C25.5523 17 26 17.4477 26 18C26 18.5523 25.5523 19 25 19H21.874C21.5122 20.4056 20.4056 21.5122 19 21.874V25C19 25.5523 18.5523 26 18 26C17.4477 26 17 25.5523 17 25V22H14V25C14 25.5523 13.5523 26 13 26C12.4477 26 12 25.5523 12 25V22H9V25C9 25.5523 8.55229 26 8 26C7.44772 26 7 25.5523 7 25V21.874C5.59439 21.5122 4.4878 20.4056 4.12602 19H1C0.447715 19 0 18.5523 0 18C0 17.4477 0.447715 17 1 17H4V14H1C0.447715 14 0 13.5523 0 13C0 12.4477 0.447715 12 1 12H4V9H1C0.447715 9 0 8.55229 0 8C0 7.44772 0.447715 7 1 7H4.12602C4.4878 5.59439 5.59439 4.4878 7 4.12602V1ZM11 9C9.89543 9 9 9.89543 9 11V15C9 16.1046 9.89543 17 11 17H15C16.1046 17 17 16.1046 17 15V11C17 9.89543 16.1046 9 15 9H11Z",
    fill: "#666AF6"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMemory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/memory.85492509c678bfd1d551db28872ea914.svg";